import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-dropdown',
  templateUrl: './fm-dropdown.component.html',
  styleUrls: ['./fm-dropdown.component.scss'],
})
export class FmDropdownComponent {
  @Input() title: string;
  public open = false;

  toggleOpen() {
    this.open = !this.open;
  }

  toggleClose() {
    this.open = false;
  }
}
